module.exports = __webpack_public_path__ + "static/media/utsettingKanoKajakk.5f159056.svg";